export default "__VITE_PUBLIC_ASSET__098b2fd2__"